import React, { Component } from 'react';

import './value-list.scss';

import { ValueListAPI } from '@philips-emr/tws-components-api';
import { Density, Direction } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { array, oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, isEnumValid } from '@philips-emr/tws-utils';

import { Field, Text } from '..';

@AwesomeComponent({ type: ComponentType.LIST, api: ValueListAPI })
class ValueList extends Component {

  static propTypes = {
    data: array.notEnumerable(),
    direction: oneOf(Object.values(Direction)),
    density: oneOf(Object.values(Density)),
  };

  static defaultProps = {
    data: [],
    density: Density.REGULAR,
    direction: Direction.HORIZONTAL,
  };

  getClassName() {
    const { direction, density } = this.props;

    return classNames({
      'c-value-list': true,
      [`c-value-list--${direction}`]: isEnumValid(Direction, direction),
      [`c-value-list--${density}`]: isEnumValid(Density, density),
    });
  }

  renderValues() {
    const { data } = this.props;

    if (!Array.isArray(data)) {
      return null;
    }

    return data.map(({ label, value }, index) => (
      <li className="c-value-list__item"  key={`${index}-${value}`} >
        <Field label={label} width={0}>
          {Array.isArray(value)
            ? value.map((text, index) => <Text className="u-truncate" key={index}>{text}</Text>)
            : <Text className="u-truncate">{value}</Text>}
        </Field>
      </li>
    ));
  }

  render() {
    return (
      <div className={this.getClassName()}>
        <ul className="c-value-list__items">
          {this.renderValues()}
        </ul>
      </div>
    );
  }
}

export default ValueList;
